export default __webpack_public_path__ + "static/media/tier1.8cd9d68e.png";